import axios from 'axios';
const department = {
    
	actions: {
		processdepartment(context, userdata){
			return new Promise((resolve, reject) => {				
				axios({url: '/Department/ProcessDepartment', data: userdata, method: 'POST' })
				.then(resp => resp.data)
				.then(respdata => {	                   									
					resolve(respdata)
				})
				.catch(err => {									
					reject(err)
				})
			})
		},	
		getdepartment({rootState}){
			return new Promise((resolve, reject) => {				
				axios.get('/Department/GetDepartment?Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getDepartmentbyid({rootState},Id){
			return new Promise((resolve, reject) => {				
				axios.get('/Department/GetDepartmentbyId?Id='+Id+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		},   
		getdepartmentbysearch({rootState},searchVal){
			return new Promise((resolve, reject) => {				
				axios.get('/Department/GetDepartmentbySearch?SearchItem='+searchVal+'&Username='+rootState.auth.token)
				.then(resp => resp.data)
				.then(respdata => {					
					resolve(respdata)
				})
				.catch(err => {					
					reject(err)
				})
			})
		}    
	}
}

export default department